<template>
  <div class="child-status">
    <div class="child-status-label-wrapper">
      <icon-base class="icon"
                 v-if="incativeMoreThenHour"
                 width="15"
                 height="15"
                 view-box="0 0 15 15"
                 icon-color="#f35d5d">
        <icon-attention/>
      </icon-base>

      <div v-if="primaryDevice.last_seen" class="label" :class="labelClasses">
        <div class="status" :class="statusClasses">
          {{ $t("status") }}:
        </div>

        <div>
          {{ $t("lastOnline") }} {{ primaryDevice.last_seen | localDateTime }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { dateDiffFromNow } from '@/services/intl'

  export default {
    props: {
      childId: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
      }),

      child() {
        return this.getChildById(this.childId)
      },

      primaryDevice() {
        return this.child.devices.find(device => device.id === this.child.primary_device_id)
      },

      userInactiveTime() {
        return dateDiffFromNow(this.primaryDevice.last_seen, 'minute')
      },

      incativeMoreThenHour() {
        return this.userInactiveTime > 60
      },

      labelClasses() {
        return {
          'label-expired': this.incativeMoreThenHour
        }
      },

      statusClasses() {
        return {
          'status-expired': this.incativeMoreThenHour
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .child-status {
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 14px;
    line-height: 1;
    color: #3e3a3b;

    padding: 5px 0;

    &-label-wrapper {
      display: flex;
      align-items: center;

      .icon {
        margin-right: 4px;
      }

      .label {
        display: flex;
        color: rgba(#3e3a3b, .5);

        &-expired {
          color: #F35D5D;
        }

        .status {
          margin-right: 5px;
          font-weight: bold;
          color: map.get($colors, primary);

          &-expired {
            color: #F35D5D;
          }
        }
      }
    }
  }
</style>
